module.exports = __webpack_public_path__ + "img/patio-art.26e98cdc.webp";